export {default as HgDetailPageHeader} from './_components/HgDetailPageHeader'
export {default as HgDetailPageSection} from './_components/HgDetailPageSection'
export {default as HgDetailBreadcrumbs} from './_components/HgDetailBreadcrumbs'
